import { Button } from "@/components/chadcn/Button"
import Spinner from "@/components/Spinner"
import type { CameraStatus } from "@/util/hooks/useCameraStream"
import type { RefObject } from "react"

type BarcodeScannerProps = {
  videoRef: RefObject<HTMLVideoElement | null>
  cameraStatus: CameraStatus
  isLinking: boolean
  onRetryCamera: () => void
}

const BarcodeScanner = ({
  videoRef,
  cameraStatus,
  isLinking,
  onRetryCamera,
}: BarcodeScannerProps) => (
  <div className="relative aspect-square w-full overflow-hidden rounded-lg bg-primary-contrast">
    <video ref={videoRef} autoPlay muted playsInline className="h-full w-full object-cover" />
    <div
      aria-hidden
      className="pointer-events-none absolute inset-8 rounded-md border-4 border-primary"
    />
    {cameraStatus === "requesting" && (
      <div className="absolute inset-0 flex items-center justify-center">
        <Spinner />
      </div>
    )}
    {(cameraStatus === "denied" || cameraStatus === "unavailable") && (
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 p-8 text-center text-white">
        <p className="text-base">The camera is not available yet.</p>
        <Button type="button" size="sm" onClick={onRetryCamera}>
          Allow camera access
        </Button>
      </div>
    )}
    {isLinking && (
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-primary-contrast/70 text-white">
        <Spinner />
        <span className="text-base">Linking your device...</span>
      </div>
    )}
  </div>
)

export default BarcodeScanner
